import SearchChips from 'components/SearchChips/SearchChips';
import SectionHeader from 'components/SectionHeader/SectionHeader';
import SelectTimePeriod from 'components/SearchInputs/SelectTimePeriod';
import SelectUmpireLeagues from 'components/SearchInputs/SelectUmpireLeagues';
import { useReportId } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';
import useUmpireAdminReport from 'hooks/UmpireReport/AdminOverview/useUmpireAdminReport';

type Props = {
  isSearchCriteriaOpen: boolean;
  setSearchCriteriaOpen: () => void;
};

const AdminSearchCriteria = ({ isSearchCriteriaOpen, setSearchCriteriaOpen }: Props) => {
  const { isCreate } = useReportId();

  const { searchCriteria, setSearchCriteria, searchChips } = useUmpireAdminReport();

  const { t } = useTranslation();

  return (
    <>
      <SectionHeader
        isOpen={isSearchCriteriaOpen}
        onClick={isCreate ? setSearchCriteriaOpen : undefined}
        title={t('Populate report')}
        isEnabled={isCreate}
      />
      {isSearchCriteriaOpen ? (
        <div className='report-layout-shelf-section'>
          <SelectTimePeriod
            selectedSeasonNames={searchCriteria.seasonNames}
            onChange={(seasonNames, dateRanges) =>
              setSearchCriteria({
                dateRanges,
                seasonNames,
                leagues: undefined,
              })
            }
          />
          <SelectUmpireLeagues
            selectedLeagues={searchCriteria.leagues}
            onChange={(leagues) => setSearchCriteria({ leagues })}
            dateRanges={searchCriteria.dateRanges}
          />
        </div>
      ) : (
        searchChips.dateRanges && (
          <SearchChips
            seasonNames={searchChips.seasonNames}
            dateRanges={searchChips.dateRanges}
            otherChips={{ ...searchChips, dateRanges: undefined, seasonNames: undefined }}
          />
        )
      )}
    </>
  );
};

export default AdminSearchCriteria;
